import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import NoIndex from "../components/NoIndex";
import { BrandLogo } from "../components/BrandLogo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr(null);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (ex) {
      setErr(formatApiError(ex));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16">
      <NoIndex title="Reset your password · ConfirmPH" />
      <Link to="/" className="flex justify-center mb-6" data-testid="forgot-brand-link">
        <BrandLogo variant="full" className="h-16 w-auto" alt="ConfirmPH" testId="forgot-brand-logo" />
      </Link>
      <div className="bg-white rounded-2xl border border-slate-200 p-6 sm:p-8 shadow-sm">
        <h1 className="font-display text-2xl font-semibold text-slate-900">Forgot your password?</h1>
        <p className="text-sm text-slate-600 mt-2">
          Enter the email you signed up with and we'll send you a secure link to set a new password.
        </p>

        {done ? (
          <div
            data-testid="forgot-success"
            className="mt-6 rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800"
          >
            <p className="font-medium">Check your inbox.</p>
            <p className="mt-1">
              If an account exists for <strong>{email}</strong>, we just sent a reset link.
              It expires in 60 minutes. Don't forget to check your spam folder.
            </p>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700" htmlFor="email">Email</label>
              <input
                id="email"
                data-testid="forgot-email-input"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 w-full px-3.5 py-2.5 rounded-lg border border-slate-300 focus:border-[#2D6A4F] focus:ring-1 focus:ring-[#2D6A4F] outline-none"
              />
            </div>
            {err && (
              <div data-testid="forgot-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
                {err}
              </div>
            )}
            <button
              type="submit"
              data-testid="forgot-submit-btn"
              disabled={loading}
              className="w-full px-4 py-3 rounded-lg btn-brand font-medium disabled:opacity-60"
            >
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}

        <div className="mt-5 text-sm text-slate-600">
          Remembered it?{" "}
          <Link to="/login" className="font-medium text-[#1B4332] hover:underline" data-testid="forgot-back-to-login">
            Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
